module.exports = __webpack_public_path__ + "img/logo.3385b97e.png";